import {
	HttpEvent,
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

// The server has no other way to know which language the UI is currently
// showing (the JWT's Language claim only reflects the language at login time).
export const languageInterceptor: HttpInterceptorFn = (
	request: HttpRequest<unknown>,
	next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
	const translateService = inject(TranslateService);

	if (request.url.startsWith(environment.NewApiPath)) {
		const lang = translateService.getCurrentLang();
		if (lang) {
			request = request.clone({ setHeaders: { languageCode: lang } });
		}
	}

	return next(request);
};
